import ProposalState from "../../Types/states/ProposalState";

const proposalInitialState:ProposalState = [];

export default proposalInitialState;
